import Vue from "vue";
import { Component } from "vue-property-decorator";
import {
    NotificationAskReception,
    UserInfos,
    NotificationReception,
} from "@/components";
import { IReceptionNotification } from "@/models";

@Component({
    name: "sidebar",
    components: {
        "userinfos": UserInfos,
        "notification-askReception": NotificationAskReception,
        "notification-reception": NotificationReception,
    },
})

export default class SidebarReception extends Vue {
    public collapsed: boolean;

    constructor() {
        super();

        this.collapsed = true;
    }

    public toggleCollapsed(): void {
        this.collapsed = this.collapsed ? false : true;
    }

    public get notifications(): IReceptionNotification[] {
        return this.$store.getters["receptions/getNotifications"]();
    }
}
